import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react/legacy'

import { useAgentSuggestedPrompts } from '~/hooks/useAgentSuggestedPrompts'
import { trackEvent, TrackingEvent } from '~/utils/trackingProvider'

import { useAgentChat } from '../AgentChatContext'
import ChatInput from './ChatInput'
import ChatMessagesView from './ChatMessagesView'
import { SuggestedPrompts } from './SuggestedPrompts'

import styles from './AgentChat.module.scss'

const AgentChat = () => {
  const { messages, isLoading, sendMessage, error, startSession } =
    useAgentChat()
  const { t } = useTranslation('Agent')
  const suggestedPrompts = useAgentSuggestedPrompts()

  const hasAnyMessages = messages.some((msg) => !msg.isLoading)

  return (
    <div className={styles.chatContainer}>
      <ChatMessagesView isLoading={isLoading} messages={messages} />
      {error && (
        <div className={styles.errorContainer}>
          <KibTopLevelAlert heading={t('Agent:ERROR')} severity="error">
            <div className={styles.errorContent}>
              {error}
              <div className={styles.retryButtonContainer}>
                <KibButtonNew
                  disabled={isLoading}
                  size="small"
                  theme="utility"
                  onClick={startSession}
                >
                  {t('Agent:RETRY')}
                </KibButtonNew>
              </div>
            </div>
          </KibTopLevelAlert>
        </div>
      )}
      {!hasAnyMessages && !error && (
        <SuggestedPrompts
          suggestedPrompts={suggestedPrompts}
          onSuggestedPromptClick={(prompt) => {
            trackEvent(TrackingEvent.AI_ASSISTANT_SUGGESTED_PROMPT_CLICKED, {
              prompt_id: prompt.id,
              prompt_text: prompt.buttonText,
            })
            sendMessage(prompt.prompt)
          }}
        />
      )}
      <ChatInput
        disabled={isLoading || Boolean(error)}
        placeholder={t('Agent:ASK_AI_ASSISTANT')}
        onSendMessage={sendMessage}
      />
    </div>
  )
}

export default AgentChat
